import NewInterviewPage from './new-interview-page'

export default NewInterviewPage